import disableContextmenu from './module/disableContextmenu.js';
import MyLazyLoad from './module/MyLazyLoad.js';
import SwitchBtnEvent from './module/SwitchBtnEvent.js';
import Calender from './module/Calender.js';
import Modal from './module/Modal.js';
import DateScroll from './module/DateScroll.js';
import MylistBtn from './module/MylistBtn.js';


$(function(){

	DateScroll();
	
	const ttlBtn = $('.p-search-select-narrow__ttl-btn')
		if(ttlBtn) {
			$('.p-search-select-narrow__ttl-btn').on('click',function(){
				$(this).toggleClass('is-active');
				$('.p-search-select-narrow__body').slideToggle();
				return false;;
			});
		}

	var a = $('.js-calendar'),
		b = $('.js-calendar-open'),
		c = $('.js-calendar-overlay');

	b.on('click',function(){
		a.toggleClass('is-active');
	});
	
	c.on('click',function(){
		a.toggleClass('is-active');
	});
});

//アコーディオオン切り替え
$(function(){
	var a = $('.js-accordion dt');
	a.on('click',function(){
		$(this).toggleClass('is-active');
		$(this).next().stop().slideToggle();
	});
});

//セレクト切り替え
$(function(){
	var a = $('.js-select dl'),
		b = $('.js-select-open'),
		c = $('.js-select');

	b.on('change',function(){
		var idx = b.find('option:selected').val();
		c.addClass('is-active');
		setTimeout(function(){
			c.removeClass('is-active');
    	},600);

		if(idx == 'all'){
			a.addClass("is-active");
		}else{
			a.removeClass("is-active").eq(idx).addClass("is-active");
		}
	});
	
});

(function() {

	window.addEventListener('load', () => {

		setTimeout(() => {//ヘッダーなどの；読み込みが終わってから処理開始
				const myLazyLoad = new MyLazyLoad();
				myLazyLoad.start();
				SwitchBtnEvent();
				disableContextmenu();
				Calender();
				Modal();

		}, 0)

		setTimeout(() => {//ヘッダーなどの；読み込みが終わってから処理開始
				//星ボタンクリックのアクション
				const mylistBtn = new MylistBtn();
		}, 1000) 
	});
	const program = document.querySelector('.p-program-all');

	if(program) {
			let swiper, swiperBool;
			const breakPoint = 1100;

			window.addEventListener('load', () => {
			if (breakPoint > window.innerWidth) {
					swiperBool = false;
			} else {
					createSwiper();
					swiperBool = true;
			}
			}, false);

			window.addEventListener('resize', () => {
			if (breakPoint > window.innerWidth && swiperBool) {
					swiper.destroy(false, true);
					swiperBool = false;
			} else if (breakPoint <= window.innerWidth && !(swiperBool)) {
					createSwiper();
					swiperBool = true;
			}
			}, false);

			function createSwiper() {
					let programSwipers = document.getElementsByClassName('p-program-all');
					for(let i = 0; i < programSwipers.length; i++) {
							swiper = new Swiper(programSwipers[i], {
									slidesPerView: 1.271,
									spaceBetween: 10,
									speed: 1000,
									touchStartPreventDefault: false,
									// Navigation arrows
									navigation: {
									nextEl: '.p-program__next',
									prevEl: '.p-program__prev',
									},
							});
					}
			
			}

			let programMores = document.getElementsByClassName('p-program-more');
			for(let i = 0; i < programMores.length; i++) {
					programMores[i].addEventListener('click', function(){
							console.log(this.parentNode.parentNode.nextElementSibling)
							this.parentNode.parentNode.classList.add('is-hide');
							this.parentNode.parentNode.nextElementSibling.classList.add('is-show');
					});
			}

			
		}
	

})(); 

